Number.prototype.padLeft = function (n,str){
	return Array(n-String(this).length+1).join(str||'0')+this;
};


// WEBPACK FOOTER //
// ./helpers/Extensions.js